import { IonButton, IonInput, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup, IonTextarea } from '@ionic/react';
import React from 'react';
import GooglePlacesAutocomplete, { geocodeByAddress, geocodeByLatLng } from 'react-google-places-autocomplete';
import { geocodeByPlaceId } from 'react-places-autocomplete';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { SmallText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { forwardTo, goBack, isEmptyObject, validateForm } from '../../lib/utils';
import { addDeliveryAddress, getNearestLocation, saveDeliveryDataTemporarily, showToast, storeDeliveryAddress } from '../../store/actions';
import '../clickAndCollect/index.css';
import './index.css';
import { getEnv } from '../../lib/env';
import FieldWrapper from '../../components/fieldWrapper';
import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";
import { ReactComponent as LocationIcon } from '../../assets/images/distance.svg';

class DeliveryAddressCheck extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            scriptLoaded: false,
            showAddressData: false,
            address: null,
            lat: null,
            lng: null,
            addressLine1: '',
            addressLine2: '',
            place: '',
            postalCode: '',
            notes: '',
            streetNumber: '',
            street: '',
            plusCode: '',
            formattedAddress: '',
            showRestaurants: false,
            checkedCodeDataIndex: null,
            zoom: 18,
            formErrors: {},
        }
        this.formConfig = {
            addressLine1: { required: true },
            addressLine2: { required: false },
            place: { required: true },
            postalCode: { required: true }
        };
    };
    handleSelect = (address) => {
        geocodeByPlaceId(address.value?.place_id).then((results) => {
            const result = results[0];
            address.value = result
            const location = result?.geometry?.location;
            if (location) {
                this.setState({
                    address,
                    lat: location.lat(),
                    lng: location.lng(),
                    mapShouldFollow: true,
                });
            }
        })

    };

    handleMapIdle = (e) => {
        const lat = e.map.center.lat();
        const lng = e.map.center.lng();
        this.setState({
            mapShouldFollow: false,
            lat, lng
        }, () => {
            geocodeByLatLng({ lat, lng }).then((results) => {
                if (results[0]) {
                    const address = {
                        label: results[0].formatted_address,
                        value: results[0]
                    };
                    this.setState({ address });
                }
            });
        });


    };


    handleInput = (key, val) => {
        this.setState({ [key]: val });
    };

    loadGoogleMapsScript = () => {
        if (!document.querySelector('#google-maps-script')) {
            const script = document.createElement('script');
            script.id = 'google-maps-script';
            script.src = `https://maps.googleapis.com/maps/api/js?key=${getEnv('GOOGLE_API_KEY')}&libraries=places`;
            script.async = true;
            script.defer = true;
			script.setAttribute('nonce', 'nonce-tU9QXE2MMxqhPUGR')

            script.onload = () => {
                this.setState({ scriptLoaded: true });
                console.log('Google Maps script loaded successfully');
            };

            script.onerror = () => {
                console.error('Error loading Google Maps script');
            };

            document.body.appendChild(script);
        } else {
            this.setState({ scriptLoaded: true });
        }
    };
    componentDidMount() {
        this.loadGoogleMapsScript();



    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.scriptLoaded && this.state.scriptLoaded !== prevState.scriptLoaded) {
            let lat = 0;
            let lng = 0;
            const myLocation = this.props.myLocation
            if (myLocation.latitude && myLocation.longitude) {
                lat = myLocation.latitude
                lng = myLocation.longitude
            } else {
                const defaultMapPosition = getConfig().general.defaultMapPosition || { lat: 51.5007, lng: 0.1246 }
                lat = defaultMapPosition.lat
                lng = defaultMapPosition.lng
            }
            this.setState({
                lat,
                lng,
            }, () => {
                geocodeByLatLng({ lat, lng }).then((results) => {
                    if (results[0]) {
                        const address = {
                            label: results[0].formatted_address,
                            value: results[0]
                        };
                        this.setState({ address });
                    }
                });
            })

        }
        if (this.props.nearestLocationsFetchingStarted !== prevProps.nearestLocationsFetchingStarted && !this.props.nearestLocationsFetchingStarted) {
            const copiedRestaurants = JSON.parse(JSON.stringify(this.props.restaurants));
            const filteredRestaurants = copiedRestaurants.filter((restaurant) => !restaurant.can_charter_delivery_order);
            let deliveryZone = JSON.parse(JSON.stringify(this.props.checkedCodeData)).filter((el) => filteredRestaurants.every((fd) => fd.id !== el.restaurant_id));

            if (deliveryZone[0]) {
                this.setState({ deliveryZone, restaurant: deliveryZone[0] }, () => {
                    Basket.setDeliveryPrice(deliveryZone[0].delivery_zone.price)
                    Basket.setDeliveryMinOrder(deliveryZone[0].delivery_zone.min_order);
                    if (!this.props.location?.state?.scheduled) {

                        this.saveAddressAndContinue()
                    } else {
                        this.setState({ showRestaurants: true })
                    }

                })
            }


        }
    }


    saveAddressAndContinue = () => {
        const { restaurants } = this.props;
        const { restaurant } = this.state;
        const address = {
            addressLine1: this.state.addressLine1,
            addressLine2: this.state.addressLine2,
            place: this.state.place,
            postalCode: this.state.postalCode,
            notes: this.state.notes,
            lat: this.state.lat,
            lng: this.state.lng
        }
        Basket.setDeliveryAddress(address);
        Basket.setRestaurant(restaurants.find((res) => res.id === restaurant.restaurant_id));
        if (!this.props.location?.state?.saveOrderData) {
            if (getConfig().general.hasServiceCharge && getConfig().general.service_charge_modules?.includes(this.props.location?.state?.scheduled ? 'scheduled-delivery' : 'charter-delivery')) {
                if (getConfig().flags.applyAutomaticServiceCharge) {
                    if (Basket.getRestaurantServiceCharge()) {
                        const service_charge_original = Basket.getRestaurantServiceCharge();
                        Basket.setServicePercentage(Number((service_charge_original[1] * 100).toFixed(2)));
                    } else {
                        const defaultServiceCharge =
                            typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;
                        if (defaultServiceCharge) {
                            Basket.setServicePercentage(Number((defaultServiceCharge[1] * 100).toFixed(2)));
                        }
                    }
                } else {
                    Basket.setServicePercentage(0);
                }
            } else {
                Basket.setServicePercentage(0);
            }
        }
        forwardTo('/delivery-address-add', {
            checkedCodeData: this.props.checkedCodeData,
            scheduled: this.props.location?.state?.scheduled ? true : false,
            skipToDeliveryTime: true
        });
    };

    checkAddress() {
        const place = this.state.address?.value;
        const errorMessage = this.props.__('Drag the pin on the map to the exact location of your address.');

        if (!place) {


            this.props.dispatch(showToast(errorMessage, 'warning'));
            return
        };
        const components = place.address_components || [];
        const streetNumberComp = components.find(c => c.types.includes("street_number"));
        const routeComp = components.find(c => c.types.includes("route"));
        const premiseComp = components.find(c => c.types.includes("premise"));
        const postalCodeComp = components.find(c => c.types.includes("postal_code"));
        const establishmentComp = components.find(c => c.types.includes("establishment"));

        const cityComp =
            components.find(c => ["locality", "postal_town", "administrative_area_level_2"].some(t => c.types.includes(t))) ||
            components.find(c => c.types.includes("administrative_area_level_1")) ||
            null;

        let addressLine1 = "";
        let addressLine2 = "";
        let streetNumber = "";
        let street = "";

        if (streetNumberComp && routeComp) {
            streetNumber = streetNumberComp.long_name;
            street = routeComp.long_name;
            addressLine1 = `${streetNumber} ${street}`;
        }
        else if (establishmentComp) {
            addressLine1 = establishmentComp.long_name;
            if (routeComp) {
                addressLine1 = `${addressLine1}, ${routeComp.long_name}`;
            }
        }
        else if (premiseComp && routeComp) {
            street = routeComp.long_name;
            addressLine1 = `${premiseComp.long_name}, ${street}`;
        }

        else if (place.name) {
            addressLine1 = place.name;
        }


        const isValid = addressLine1 !== ''


        if (isValid) {
            this.setState({
                showAddressData: true,
                addressLine1,
                addressLine2,
                streetNumber,
                street,
                postalCode: postalCodeComp?.long_name || "",
                place: cityComp?.long_name || "",
                lat: place.geometry?.location?.lat ? place.geometry.location.lat() : this.state.lat,
                lng: place.geometry?.location?.lng ? place.geometry.location.lng() : this.state.lng,
                plusCode: place.plus_code?.global_code || "",
                addressValid: isValid,
                notes: this.state.notes,
                formattedAddress: place.formatted_address
            });
        } else {
            this.props.dispatch(showToast(errorMessage, 'warning'));
        }
    }


    backHandler = () => {
        if (this.state.showAddressData) {
            this.setState({ showAddressData: false })
        } else {
            goBack();
        }
    }
    save = () => {
        const { auth, profile } = this.props;
        const address = {
            addressLine1: this.state.addressLine1,
            addressLine2: this.state.addressLine2,
            place: this.state.place,
            postalCode: this.state.postalCode,
            notes: this.state.notes,
            lat: this.state.lat,
            lng: this.state.lng
        }
        if (auth && auth.loggedIn) {
            let found = !!(profile.address_list
            ).find((al) => this.state.addressLine1 + this.state.place + this.state.postalCode === al.addressLine1 + al.place + al.postalCode);
            if (!found) {
                this.props.dispatch(
                    addDeliveryAddress({
                        ...address,
                        orderType: Basket.getOrderType().toLowerCase(),
                    }),
                );
            }
            Basket.setDeliveryAddress(address);
        } else {
            this.props.dispatch(storeDeliveryAddress(address));
            Basket.setDeliveryAddress(address);
        }
        forwardTo(this.props.location?.state?.scheduled ? '/scheduled-delivery' : '/delivery');
    }

    check = () => {
        const { postalCode, addressLine1, addressLine2, place, notes } = this.state;


        let formErrors = validateForm(this.formConfig, this.state);

        this.setState({ formErrors }, () => {
            if (Object.keys(formErrors).length === 0) {
                const tempData = {
                    addressLine1,
                    place,
                    postalCode,
                    notes
                };
                if (addressLine2) {
                    tempData.addressLine2 = addressLine2;
                }

                let charterDelivery = Basket.delivery_option.id === 'charter-delivery'


                const formattedAddress = [addressLine1, addressLine2, place, postalCode].filter(Boolean).join(', ');
                this.props.dispatch(getNearestLocation(formattedAddress, charterDelivery, Basket.delivery_option.id == 'scheduled-delivery'));
                this.props.dispatch(saveDeliveryDataTemporarily(tempData));
                this.setState({ restaurant: {}, deliveryPrice: '' });

            }
        })


    }
    checkAvailableSlotsForToday = (restaurant) => {
        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        let today = days[moment().format('d')];
        const day = {
            Monday: 'w1',
            Tuesday: 'w2',
            Wednesday: 'w3',
            Thursday: 'w4',
            Friday: 'w5',
            Saturday: 'w6',
            Sunday: 'w0',
        };
        let selectedRestaurant = this.props.restaurants.find((r) => r.id === restaurant.restaurant_id);
        let deliveryTimes = selectedRestaurant.charter_delivery_times_json;

        let flag = false;
        if (!isEmptyObject(deliveryTimes)) {
            for (let i = 0; i < deliveryTimes.length; i++) {
                deliveryTimes[i].availability.forEach((dt) => {
					if (dt.d === day[today] && dt?.active !== false) {
                        let addedTime = null;
                        addedTime = moment().add(restaurant.charter_delivery_order_slot_lead_time, 'minutes');
                        if (addedTime.isBefore(moment(dt.end, 'hh:mm'))) {
                            flag = true;
                        }
                    }
                });
            }
        }
        return flag;
    };
    handleInputClick = () => {
        this.setState({ address: null });
    };

    proceedToOrder = (id) => {
        this.setState({
            restaurant: this.props.checkedCodeData[id],
        }, () => {

            this.saveAddressAndContinue()
        })
    };
    render() {
        const { __, checkedCodeData } = this.props;
        const { checkedCodeDataIndex } = this.state
        const headerTitle = this.state.showRestaurants ? __('Select restaurant') : this.state.showAddressData ? __('Address details') : __('Add new address')
        const canEditAddressFields = !getConfig().flags.removeEditOnAddressFields
        return (
            <Layout showHamburger={!this.state.showAddressData && (!this.props.auth?.loggedIn || !this.props.profile?.address_list?.length)} showLoginIcon={getConfig().flags.hasGuestCheckout && Basket.itemsCount() == 0} backHandler={this.backHandler} title={headerTitle} headerWithTitle={true} color="transparent">
                <Title className={'web-only'}>{headerTitle}</Title>
                {this.state.scriptLoaded &&
                    <>
                        {this.state.showRestaurants ?
                            <>
                                <IonList lines="none" className={` ${getConfig().general.tiledRestaurantView ? 'tiled-box-wrapper' : 'box-wrapper'}`}>
                                    <IonRadioGroup onIonChange={(event) => this.setState({ checkedCodeDataIndex: event.detail.value })} value={checkedCodeDataIndex} >
                                        {checkedCodeData
                                            .sort((a, b) => {
                                                return a.delivery_zone.price - b.delivery_zone.price;
                                            })
                                            .map((restaurant, i) => {
                                                const { restaurant_name, restaurant_address, delivery_zone, restaurant_id } = restaurant;
                                                const image = this.props.restaurants.find(el => el.id == restaurant_id)?.image || ''

                                                const price = restaurant.delivery_zone.price;
                                                let availableSlosts = this.checkAvailableSlotsForToday(restaurant);

                                                return (
                                                    <React.Fragment key={`restaurant_${i}`}>
                                                        {getConfig().general.tiledRestaurantView ?
                                                            <IonItem
                                                                className="pointer box-wrapper"
                                                                disabled={!availableSlosts}
                                                                onClick={() => this.proceedToOrder(i)}
                                                                lines="none"
                                                                key={i}
                                                            >
                                                                <div style={{ width: '100%' }}>
                                                                    <img src={image} />
                                                                    <div>
                                                                        <StrongText className='block text-to-update'>{__(restaurant_name)}</StrongText>
                                                                        <div className="restaurant-data" >
                                                                            {!getConfig().flags.removeDeliveryRestaurantAdditionalInformation && (
                                                                                <>
                                                                                    <SmallText className='block'>

                                                                                        {price > 0
                                                                                            ? restaurant?.delivery_charge_in_percent
                                                                                                ? `${__('Delivery price')} -  ${price}%`
                                                                                                : `${__('Delivery price')} - ${Basket.formatPrice(price)}`
                                                                                            : `${__('Free Delivery')}`}
                                                                                    </SmallText>

                                                                                    <SmallText className="block">
                                                                                        {__('Minimun Order')} - {Basket.formatPrice(delivery_zone.min_order)}
                                                                                    </SmallText>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <SmallText className="restaurant-status" >{!availableSlosts ? __('Service Unavailable') : ` ${__('OPEN')}`}</SmallText>
                                                                </div>
                                                            </IonItem> :
                                                            <IonItem key={i} lines='none' className='restaurant-wrapper'>
                                                                <div tabIndex="-1"></div>
                                                                <IonRadio disabled={!availableSlosts} color='primary' slot="start" value={i} />
                                                                <IonLabel className="ion-text-wrap" color="dark">
                                                                    <StrongText className='block text-to-update'>{restaurant_name}</StrongText>
                                                                    <SmallText className="block">{restaurant_address}</SmallText>
                                                                    <div className="delivery-additional-restaurant-information">
                                                                        {!getConfig().flags.removeDeliveryRestaurantAdditionalInformation && (
                                                                            <div>
                                                                                {price > 0 ? (
                                                                                    <SmallText>
                                                                                        {__('Delivery charge')} - {Basket.formatPrice(price)}
                                                                                    </SmallText>
                                                                                ) : (
                                                                                    <SmallText>{__('Free Delivery')}</SmallText>
                                                                                )}
                                                                                <SmallText className="block">
                                                                                    {__('Minimun Order')} - {Basket.formatPrice(delivery_zone.min_order)}
                                                                                </SmallText>
                                                                            </div>
                                                                        )}
                                                                        <SmallText className="restaurant-opening-time">
                                                                            {' '}
                                                                            {!availableSlosts ? __('Service Unavailable') : ` ${__('OPEN')}`}
                                                                        </SmallText>
                                                                    </div>
                                                                </IonLabel>
                                                            </IonItem>
                                                        }</React.Fragment>
                                                );
                                            })}
                                    </IonRadioGroup>
                                </IonList>
                                {!getConfig().general.tiledRestaurantView &&
                                    <>
                                        <Spacer size={5} />
                                        <IonButton disabled={this.state.checkedCodeDataIndex == null} expand='block' onClick={() => this.proceedToOrder(this.state.checkedCodeDataIndex)}>{__('Continue')}</IonButton>
                                    </>
                                }

                            </>
                            :
                            <>

                                {this.state.showAddressData ?
                                    <div className='scrollable-y'>
                                        <div className='map-preview pointer'>
                                            <div className='map-preview-overlay' onClick={() => this.setState({ showAddressData: false })}>
                                                <StrongText>{__('Review pin position')}</StrongText>
                                            </div>
                                            <APIProvider apiKey={getEnv('GOOGLE_API_KEY')} >

                                                <Map
                                                    mapId={'map_1'}
                                                    zoom={18}
                                                    center={{ lng: this.state.lng, lat: this.state.lat }}
                                                    clickableIcons={false}

                                                    options={{
                                                        disableDefaultUI: true
                                                    }}>
                                                    <AdvancedMarker position={{ lat: this.state.lat, lng: this.state.lng }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="42" viewBox="0 0 30 42" fill="none">
                                                            <g filter="url(#filter0_d_198_1958)">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25 11.0085C25 5.50991 20.4967 1 14.9669 1C9.43709 1 5 5.51094 5 11.0085C5 20.5885 14.9669 33 14.9669 33C14.9669 33 25 20.5885 25 11.0085ZM19.7358 11.173C19.7358 13.7404 17.5493 15.8473 14.9669 15.8473C12.3844 15.8473 10.2651 13.7404 10.2651 11.173C10.2651 8.60559 12.3834 6.43286 14.9669 6.43286C17.5504 6.43286 19.7358 8.60559 19.7358 11.173Z" fill="var(--ion-color-primary)" />
                                                            </g>
                                                            <defs>
                                                                <filter id="filter0_d_198_1958" x="0.5" y="0.5" width="29" height="41.2969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                                    <feOffset dy="4" />
                                                                    <feGaussianBlur stdDeviation="2" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_198_1958" />
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_198_1958" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </AdvancedMarker>
                                                </Map>
                                            </APIProvider>
                                        </div>
                                        {canEditAddressFields ? <>
                                            <div className='input-field-container'>
                                                <StrongText>{__('Street & number')}</StrongText>
                                                <FieldWrapper error={this.state?.formErrors?.addressLine1}>
                                                    <IonInput
                                                        type="text"
                                                        pattern="text"
                                                        inputmode="text"
                                                        value={this.state.addressLine1}
                                                        onIonInput={(e) => this.handleInput('addressLine1', e.target.value)}

                                                    />
                                                </FieldWrapper>

                                            </div>
                                            <div className='input-field-container'>
                                                <StrongText>{__('Apartment, floor, building (optional)')}</StrongText>
                                                <FieldWrapper >
                                                    <IonInput
                                                        type="text"
                                                        pattern="text"
                                                        inputmode="text"
                                                        value={this.state.addressLine2}
                                                        onIonInput={(e) => this.handleInput('addressLine2', e.target.value)}
                                                    />
                                                </FieldWrapper>

                                            </div>
                                            <div className='input-field-container'>
                                                <StrongText>{__('City')}</StrongText>
                                                <FieldWrapper error={this.state?.formErrors?.place}>
                                                    <IonInput
                                                        type="text"
                                                        pattern="text"
                                                        inputmode="text"
                                                        value={this.state.place}
                                                        onIonInput={(e) => this.handleInput('place', e.target.value)}
                                                    />
                                                </FieldWrapper>

                                            </div>
                                            <div className='input-field-container'>
                                                <StrongText>{__('Postal Code')}</StrongText>
                                                <FieldWrapper error={this.state?.formErrors?.postalCode} >
                                                    <IonInput
                                                        type="text"
                                                        pattern="text"
                                                        inputmode="text"
                                                        value={this.state.postalCode}
                                                        onIonInput={(e) => this.handleInput('postalCode', e.target.value)}
                                                    />
                                                </FieldWrapper>

                                            </div>


                                        </> : <>
                                            <div className='box-content order-header-content'>
                                                <div>
                                                    <LocationIcon className='fill-label' />
                                                    <StrongText className='text-to-update'>{[this.state.addressLine1, this.state.place, this.state.postalCode].filter(Boolean).join(', ')}</StrongText>
                                                </div>

                                            </div>
                                            <Spacer size={5} />
                                            <div className='input-field-container'>
                                                <StrongText>{__('Apartment, floor, building (optional)')}</StrongText>
                                                <FieldWrapper >
                                                    <IonInput
                                                        type="text"
                                                        pattern="text"
                                                        inputmode="text"
                                                        value={this.state.addressLine2}
                                                        onIonInput={(e) => this.handleInput('addressLine2', e.target.value)}
                                                    />
                                                </FieldWrapper>

                                            </div>
                                        </>}

                                        <div className="input-field-container">
                                            <StrongText>{__('Driver notes')}</StrongText>
                                            <FieldWrapper>
                                                <IonTextarea
                                                    onIonInput={(e) => this.handleInput('notes', e.target.value)}
                                                    type="text"
                                                    pattern="text"
                                                    inputmode="text"
                                                    value={this.state.notes}
                                                ></IonTextarea>
                                            </FieldWrapper>
                                        </div>

                                        <IonButton expand='block' onClick={() => this.check()}>{__('Save')}</IonButton>
                                    </div> :
                                    <div className='full-map-wrapper'>

                                        <div className='full-map-search'>
                                            <div className="input-field-container">
                                                <FieldWrapper >
                                                    <GooglePlacesAutocomplete
                                                        selectProps={{
                                                            onMenuOpen: this.handleInputClick,
                                                            menuPortalTarget: document.body,
                                                            value: this.state.address,
                                                            onChange: (address) => this.handleSelect(address),
                                                            placeholder: "Start typing your address...",
                                                            styles: {
                                                                control: (provided, state) => ({
                                                                    ...provided,
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: 'transparent !important',
                                                                    outline: "none !important",
                                                                    boxShadow: 'none !important'


                                                                }),
                                                                input: (provided) => ({
                                                                    ...provided,
                                                                    outline: "none !important",
                                                                    borderColor: 'transparent !important',
                                                                }),
                                                                singleValue: (provided) => ({
                                                                    ...provided,
                                                                    outline: "none !important",
                                                                    borderColor: 'transparent !important',
                                                                    color: '#000000'
                                                                }),
                                                                option: (provided, state) => ({
                                                                    ...provided,
                                                                    cursor: 'pointer',
                                                                }),
                                                                container: (provided, state) => ({
                                                                    ...provided,
                                                                    width: '100%',
                                                                    outline: "none !important",
                                                                    borderColor: 'transparent !important',
                                                                }),
                                                            },
                                                        }}
                                                        autocompletionRequest={{
                                                            componentRestrictions: {
                                                                country: [getConfig().general.defaultState || 'UK'],
                                                            },
                                                        }}
                                                    />
                                                </FieldWrapper>
                                            </div>                            </div>

                                        <div className='full-map-display' >
                                            {this.state.lng && this.state.lat &&
                                                <APIProvider apiKey={getEnv('GOOGLE_API_KEY')} >

                                                    <Map defaultCenter={{ lng: this.state.lng, lat: this.state.lat }} center={this.state.mapShouldFollow ? { lat: this.state.lat, lng: this.state.lng } : undefined}
                                                        clickableIcons={false}
                                                        gestureHandling="greedy"

                                                        mapId={'map_id'}
                                                        defaultZoom={18}
                                                        onIdle={(e) => this.handleMapIdle(e)}
                                                        options={{
                                                            disableDefaultUI: true
                                                        }}>
                                                        <svg className='map-pin' xmlns="http://www.w3.org/2000/svg" width="30" height="42" viewBox="0 0 30 42" fill="none">
                                                            <g filter="url(#filter0_d_198_1958)">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25 11.0085C25 5.50991 20.4967 1 14.9669 1C9.43709 1 5 5.51094 5 11.0085C5 20.5885 14.9669 33 14.9669 33C14.9669 33 25 20.5885 25 11.0085ZM19.7358 11.173C19.7358 13.7404 17.5493 15.8473 14.9669 15.8473C12.3844 15.8473 10.2651 13.7404 10.2651 11.173C10.2651 8.60559 12.3834 6.43286 14.9669 6.43286C17.5504 6.43286 19.7358 8.60559 19.7358 11.173Z" fill="var(--ion-color-primary)" />
                                                            </g>
                                                            <defs>
                                                                <filter id="filter0_d_198_1958" x="0.5" y="0.5" width="29" height="41.2969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                                    <feOffset dy="4" />
                                                                    <feGaussianBlur stdDeviation="2" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_198_1958" />
                                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_198_1958" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </Map>
                                                </APIProvider>
                                            }

                                        </div>


                                        <IonButton onClick={() => this.checkAddress()} expand='block'>{__('Continue')}</IonButton>
                                    </div>
                                }
                            </>
                        }

                    </>

                }
            </Layout>
        );
    }
}



const stateToProps = (state) => {
    const { profile, auth } = state.profile;
    const { checkedCodeData } = state.orders;
    const { deliveryRangeType, isChooseDeliveryModalOpen, nearestLocationsFetchingStarted, myLocation } = state.common;
    const { restaurants } = state.restaurants;
    return {
        profile,
        auth,
        checkedCodeData,
        deliveryRangeType,
        isChooseDeliveryModalOpen,
        restaurants,
        nearestLocationsFetchingStarted,
        myLocation
    };
};

export default connect(stateToProps)(withTranslation(DeliveryAddressCheck));